import { render, staticRenderFns } from "./OpcionColorBtn.vue?vue&type=template&id=2f79230d"
import script from "./OpcionColorBtn.vue?vue&type=script&lang=js"
export * from "./OpcionColorBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports